import { AppBar, Box, Toolbar, IconButton } from "@mui/material";
import {
  LightMode as LightModeIcon,
  AccountCircle,
  Menu,
} from "@mui/icons-material";
import DetechLogo from "../assets/2022-detechtion-logo-white.png";
import SelectTenant from "../common/components/SelectTenant";
import { useDarkModeDispatch } from "../common/contexts/GlobalContext";
import { Outlet } from "react-router-dom";
import { useState, useContext } from "react";
import TCDrawer from "../common/components/TCDrawer";
import { TenantContext } from "../common/contexts/TenantContext";
import { AlertsContext } from "../common/contexts/AlertsContext";
import FeedbackModal from "../common/components/FeedbackModal";

const MainPage = () => {
  const toggleDarkMode = useDarkModeDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const tenantInfo = useContext(TenantContext);
  const { infoMessages, setInfoMessages } = useContext(AlertsContext);

  const handleChangeColorTheme = () => {
    toggleDarkMode({ type: "TOGGLE", value: true });
  };

  return (
    <>
      <TCDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <Box sx={{ flexGrow: 1 }} color='secondary'>
        <AppBar position='static'>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <IconButton
              edge='start'
              color='inherit'
              aria-label='menu'
              onClick={() => setDrawerOpen(true)}>
              <Menu />
            </IconButton>
            <div>
              <img
                src={DetechLogo}
                style={{ width: "240px" }}
                alt='Detechtion logo'
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <SelectTenant tenantInfo={tenantInfo} />
              <IconButton
                size='large'
                aria-label='account of current user'
                aria-controls='menu-appbar'
                aria-haspopup='true'
                // onClick={handleMenu}
                color='inherit'
                sx={{ mr: 2 }}>
                <AccountCircle />
              </IconButton>
              <IconButton
                size='large'
                aria-label='toggle theme'
                aria-controls='menu-appbar'
                aria-haspopup='false'
                onClick={handleChangeColorTheme}
                color='inherit'>
                <LightModeIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
      </Box>
      <Outlet />
      <FeedbackModal
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        type='snackbar'
        onClose={() => setInfoMessages({ ...infoMessages, open: false })}
        {...infoMessages}
        sx={{ zIndex: 3 }}
      />
    </>
  );
};

export default MainPage;
